import type { FaireProductEntity } from "../../entity_types/product";

export const p_5hcubkxryr: FaireProductEntity = {
  token: "p_5hcubkxryr",
  type: "product",
  name: "Sugar Free Mermaid™ Syrup",
  brandToken: "b_2mvbnj1udh",
  brandName: "Jordan's Skinny Mixes",
  imageUrl: "https://cdn.faire.com/fastly/04f0500c83c7ae51ec6387f7a1e9bfd9c11b71919300110befbea4f8e8ee2ba7.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e2c3f03c8c6d75cab4ea165a31cdba5cea5cd7dcd6c924e407dbb2da61015bbf.png",
    "https://cdn.faire.com/fastly/cc35c7a9585e7220448714be4267a30831a0639aaecf3c1d43cbd3293c457e11.png",
    "https://cdn.faire.com/fastly/324216bdaa1568d122d6bbe0df6053bf6e06223162ea526e057bf2f8c8555940.png",
    "https://cdn.faire.com/fastly/d1a66bee01c6ef37ebc7c883fd037ad66a118c4bebb64a829c7bb00ca3c166ee.png",
    "https://cdn.faire.com/fastly/c504a2b0c7c49fc1b9fbba627367b4bb2d68c2a0ed526b95145a86b359be052a.png",
    "https://cdn.faire.com/fastly/e863c36661c9dc7bad3440369c7fad58635687a538bcf41fb960215afad7215d.png"
  ],
  priceDollars: 4.5,
  description: "🤩 SOLD OUT 8X 🤩 TIKTOK VIRAL SYRUP!\n\nIntroducing the best-selling sensation from Jordan's Skinny Mixes: Sugar Free Mermaid™ Syrup! Dive into a wave of tropical delight with a splash of citrus, a hint of coconut, a touch of pineapple, and a whole lot of magic—without any of the guilt.\n\nOur Sugar Free Mermaid™ Syrup captures the whimsical essence of a mermaid’s paradise, delivering a burst of exotic, magical flavor with every sip. Whether you're mixing up mermaid-worthy cocktails, jazzing up your tea or lemonade, or whipping up fun frozen popsicles, this syrup is sure to make your creations sparkle and transport your taste buds to an underwater wonderland. \n\n * 🚫 0 Calories. 0 Sugar. 0 Carbs. \n * 💰 750 ml/25.4 fl. oz. Bottle - 25 Servings! \n * ✅ Gluten-Free & Kosher. \n * 🌱 Keto-Friendly. \n * 🇺🇸 Made in the USA. \n * ✖️ No aspartame. \nMake a splash with every sip! Elevate your drinks with a touch of magic and experience the fun and playful taste that’s captured hearts everywhere. Dive in and enjoy our best-selling syrup of all time today.\n",
  tags: [],
  msrpDollars: 8.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T18:46:36.351Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
